import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
// import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
// import VanillaTilt from 'vanilla-tilt';
import Swiper, { Navigation } from 'swiper';
// import { Fancybox } from '@fancyapps/ui';
// import '@fancyapps/ui';
// import { Gradient } from './Gradient.js';
// import { Loader } from "@googlemaps/js-api-loader";


(function ($, root, undefined) {

  'use strict';

  console.log('%cCreated by Konfiture', 'color: #000; padding: 5px 0px 1px; border-bottom:2px solid #1A1A1A;'), console.log('%chttps://konfiture.com', 'color:#ccc');

  // register GSAP plugins
  gsap.registerPlugin(ScrollTrigger, SplitText);

  // configure Swiper to use modules
  Swiper.use([Navigation]);

  let $body = $('body');
  let scroll, scrollY = window.scrollY;
  let mainScroller;

  // Set main document scroller
  if ($(window).width() > 1024) {
    mainScroller = $('.smooth-scroll');
  } else {
    mainScroller = $body;
  }

  scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    getDirection: true,
    lerp: 0.05
  });

  scroll.on('scroll', function (instance) {
    ScrollTrigger.update();

    scrollY = instance.scroll.y;

    if (scrollY >= 10) {
      $('.exp__navbar').addClass('--scrolled');
    } else {
      $('.exp__navbar').removeClass('--scrolled');
    }
  });

  // $(window).on('scroll', function(){
  //   console.log(scrollY);

  //   if (!scrollY <= 10) {
  //     $('.exp__navbar').addClass('--scrolled');
  //   } else {
  //     $('.exp__navbar').removeClass('--scrolled');
  //   }
  // })

  ScrollTrigger.scrollerProxy('[data-scroll-container]', {
    scrollTop(value) {
      return arguments.length ? scroll.scrollTo(value, 0, 0) : scroll.scroll.instance.scroll.y;
    }, // we don't have to define a scrollLeft because we're only scrolling vertically.
    getBoundingClientRect() {
      return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
    },
    // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
    pinType: document.querySelector('[data-scroll-container]').style.transform ? 'transform' : 'fixed'
  });

  // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll. 
  ScrollTrigger.addEventListener('refresh', () => scroll.update());

  // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
  ScrollTrigger.refresh();

  /**
   * Smooth scroll to anchor
   */
  function scrollToAnchor() {
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // Figure out element to scroll to
        var target = $(this);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          scroll.scrollTo(target.attr('href'), {
            offset: -$('.acs__nav').outerHeight(),
            duration: 1000,
            easing: [0.16, 1, 0.3, 1],
            disableLerp: true
          });
        }
      });

    // Back to top links
    $('a.back-to-top').on('click', function(event){
      event.preventDefault();
      scroll.scrollTo('top', {
        duration: 1000,
        easing: [0.16, 1, 0.3, 1],
        disableLerp: true
      });
    });
  }

  /**
   * Get true viewport height on mobile
   * avoiding calculating address bar height on mobile (chrome, safari...)
   */
  function initHeightVariable() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  /**
   * Toggle mobile menu
   */
  function mobileMenuAnimation() {
    let menuTl = gsap.timeline({ paused: true }),
      forward = false;

    // Mobile menu timeline animation
    menuTl.set($('.exp__mobile-menu'), {
      pointerEvents: 'auto'
    }).set($('.exp__mobile-menu > ul > li'), {
      y: '4rem'
    });

    menuTl.to($('.exp__mobile-menu__background'), {
      // autoAlpha: 1,
      y: '0%',
      duration: 1.4,
      ease: 'expo.inOut'
    }).to($('.exp__mobile-menu > ul > li'), {
      y: '0rem',
      autoAlpha: 1,
      duration: 1.2,
      ease: 'expo.out',
      stagger: .1,
      delay: -.6
    });

    $('.exp__menu-toggle').on('click', function () {
      $body.toggleClass('menu-is-open');
      $(this).toggleClass('is-active');

      forward ? menuTl.timeScale(2).reverse() : menuTl.timeScale(1).play();
      forward = forward ? false : true;
    });
  }

  /**
   * Reveal animations
   * 
   * @requires ScrollTrigger
   */
  function revealAnimations() {
    if ($('[data-reveal]').length > 0) {
      $('[data-reveal]').each(function () {
        let $revealType = $(this).data('reveal');

        // Default
        if ($revealType == 'default' || $revealType === "" ) {
          
          let $defaultItems = $(this).children();

          gsap.set($defaultItems, {
            autoAlpha: 0,
            y: '1rem'
          });

          let defaultTl = gsap.timeline({
            scrollTrigger: {
              scroller: mainScroller,
              trigger: this,
              start: 'top 60%',
              // markers: true,
              toggleActions: 'play none none none',
              // toggleActions: 'play none none reverse'
            }
          })

          defaultTl.to($defaultItems, {
            autoAlpha: 1,
            y: '0rem',
            ease: 'expo.out',
            duration: 1.2,
            stagger: .1
          })
        }

        // List
        else if ($revealType == 'list') {

          let $listItems = $(this).children();

          gsap.set($listItems, {
            autoAlpha: 0,
            y: '1rem'
          });

          let listTl = gsap.timeline({
            scrollTrigger: {
              scroller: mainScroller,
              trigger: this,
              start: 'top 60%',
              // markers: true,
              toggleActions: 'play none none none',
              // toggleActions: 'play none none reverse'
            }
          })

          listTl.to($listItems, {
            autoAlpha: 1,
            y: '0rem',
            ease: 'expo.out',
            duration: 1.2,
            stagger: .1
          })
        }

        // Picture
        else if ($revealType == 'image') {

          let $pictureItems = $(this);

          let pictureTl = gsap.timeline({
            scrollTrigger: {
              scroller: mainScroller,
              trigger: this,
              start: 'top 60%',
              // markers: true,
              toggleActions: 'play none none none'
            }
          });

          pictureTl.set($pictureItems, {
            autoAlpha: 0,
            scale: .8
          });

          pictureTl.set($pictureItems.children(), {
            autoAlpha: 0
          })

          pictureTl.to($pictureItems, {
            autoAlpha: 1,
            scale: 1,
            ease: 'expo.out',
            duration: 1,
            // stagger: .1
          });

          pictureTl.to($pictureItems.children(), {
            autoAlpha: 1,
            duration: .4,
            ease: 'expo.out',
          }, '<')
        }

      })

      // List

    }
  }

  /**
   * Main page transition in
   */
  function mainTransitionIn() {
    var titleSplit = new SplitText('.exp__h1', {
      type: 'words, chars, lines',
      wordsClass: 'split__word',
      charsClass: 'split__char'
    });

    var subtitleSplit = new SplitText('.exp__single__subtitle > p', {
      type: 'words, chars, lines',
      wordsClass: 'split__word',
      charsClass: 'split__char'
    })

    var transitionIn = gsap.timeline();

    transitionIn.set($('.exp__content'), {
      autoAlpha: 0,
      y: '4rem'
    })

    transitionIn.to($('.loader > *'), {
      autoAlpha: 0,
      duration: .6,
      ease: 'expo.out',
    }).to($('.loader'), {
      scaleX: 0,
      duration: 1.2,
      ease: 'expo.out',
    })

    transitionIn.to($('.exp__h1'), {
      autoAlpha: 1,
      duration: .1
    }, '<')

    transitionIn.to($('.exp__h1 .split__char'), {
      // autoAlpha: 1,
      y: 0,
      duration: 1.2,
      ease: 'expo.out',
      stagger: .01
    }, '<.5')

    if ($('.exp__single__subtitle .split__char').length > 0) {
      transitionIn.to($('.exp__single__subtitle .split__char'), {
        y: 0,
        duration: 1.2,
        ease: 'expo.out',
        stagger: .001,
        delay: -1.2
      })
    }

    if ($('body').hasClass('home') && $('.exp__header .--bigger').length > 0 && $(window).width() < 1024) {
      transitionIn.to($('.--bigger .split__char'), {
        y: 0,
        duration: 1.2,
        ease: 'expo.out',
        stagger: .001,
        delay: -1.2
      })
    }


    transitionIn.to($('.exp__content'), {
      y: 0,
      autoAlpha: 1,
      duration: 1.2,
      ease: 'expo.out',
      delay: -1.2
    })
  }

  /**
   * Front Page Scripts
   */
  function frontPageScripts() {
    // $('.exp__header__illustration').on('mouseenter', function(){
    //   $(this).parent().addClass('--mouseentered');
    // });

    // $('.exp__header__illustration').on('mouseleave', function(){
    //   $(this).parent().removeClass('--mouseentered');
    // });

    const refSwiper = new Swiper('.swiper-container', {
      slidesPerView: 1.5,
      direction: 'horizontal',
      spaceBetween: 30,
      freeMode: true,
      centeredSlides: true,
      breakpoints: {
        576: {
          slidesPerView: 'auto',
          initialSlide: 1
        }
      }
    });
    
    // On scroll animate header illustration
    var endTrigger, triggerEl;

    if ($(window).width() > 1024) {
      endTrigger = 'bottom bottom';
      triggerEl = '.exp__header__sticky'
    } else {
      endTrigger = 'bottom center';
      triggerEl = '.exp__header'
    }

    var illustrationTl = gsap.timeline({
      scrollTrigger: {
        scroller: mainScroller,
        trigger: triggerEl,
        start: '-1 top',
        end: endTrigger,
        scrub: true,
        // markers: true
      }
    });
    
    illustrationTl.to($('.exp__header__illustration .background'), {
      x: '0%'
    })

    // Split page subtitle
    var subtitleSplit = new SplitText('.exp__header .--bigger', {
      type: 'words, chars',
      charsClass: 'split__char',
      wordsClass: 'split__word'
    })
    
    // On scroll animate page subtitle
    if ($(window).width() > 1024) {

      ScrollTrigger.create({
        scroller: mainScroller,
        trigger: '.exp__header',
        start: 'center center',
        end: 'bottom bottom',
        // markers: true,
        onEnter: function(){
          gsap.to($('.exp__header p .split__char'), {
            // autoAlpha: 1,
            y: '0',
            duration: 1.2,
            stagger: .005,
            ease: 'expo.out'
          })
        },
        onLeaveBack: function(){
          gsap.to($('.exp__header p .split__char'), {
            // autoAlpha: 0,
            y: '4rem',
            duration: 1.2,
            stagger: .001,
            ease: 'expo.out'
          })
        }
      })
    }

    // Fix header on scroll on tablet and smartphone
    // if ( $(window).width() <= 1024 ) {
    //   ScrollTrigger.create({
    //     scroller: mainScroller,
    //     trigger: '.exp__header__sticky',
    //     start: '-1 top',
    //     end: 'bottom center',
    //     pin: true,
    //     // markers: true
    //   })
    // }

    // ScrollTrigger.create({
    //   scroller: mainScroller,
    //   trigger: '.exp__header',
    //   start: 'top center',
    //   scrub: true,
    //   markers: true,
    //   onEnter: function() {
    //     $('.exp__header').addClass('--mouseentered');
    //   },
    //   onLeaveBack: function() {
    //     $('.exp__header').removeClass('--mouseentered');
    //   }
    // })
  }

  /**
   * Page: Solutions
   */
  function solutionsScripts() {
    $('.exp__video .btn').on('click', function () {
      $(this).addClass('hide');
      $(this).siblings('video').attr('controls', true);
      $(this).siblings('video').get(0).play();
      setTimeout(
        function() {
          scroll.update()
        }, 300
      );
    });
  }

  /**
   * Form control
   */
  function formControl() {
    $('.form-control').on('focus', function(){
      $(this).parent().parent().addClass('--filled');
    });

    $('.form-control').on('blur', function(){
      if (!$(this).val()) {
        $(this).parent().parent().removeClass('--filled');
      }
    });

    // $('.form-control').on('change', function(){

    //   if ( !$(this).val() ) {
    //     $(this).parent().parent().removeClass('--filled');
    //   } else {
    //     $(this).parent().parent().addClass('--filled');
    //   }
    // });
  }

  $(window).on('load', function(){
    setTimeout( mainTransitionIn, 1000 );
  })

  $(document).ready(function () {
    // Do stuff on DOM ready
    initHeightVariable();
    mobileMenuAnimation();
    scrollToAnchor();
    revealAnimations();
    // simpleReveal();
    // simpleListReveal();

    // initSmoothScroll();

    // toggleMenu();
    // reduceNavOnScroll();

    ($('body').hasClass('home')) ? frontPageScripts() : '';
    ($('body').hasClass('page-template-solutions')) ? solutionsScripts() : '';
    ($('body').hasClass('page-template-contact')) ? formControl() : '';
  });

})(jQuery, this);